import React, { useEffect, useState } from "react";
import { useNetwork } from "../../context/NetworkContext";
import { useShowAlert } from "../../context/AlertContext";
import AxiosInstance from "../../utils/AxiosInstance";
import handleError from "../../constants/handleError";
import WeekSaleSummary from "./dashbord/WeekSaleSummary";
import uRLs from "../../utils/baseUtils";
import { usePermission } from "../../context/PermissionContext";
import TodayHistory from "./dashbord/TodayHistory";
import { useAuth } from "../../context/AuthProvider";
import GetServerLiveTime from "../../constants/GetServerLiveTime";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNavigate } from "react-router-dom";
import CardPreLoader from "./dashbord/CardPreLoader";
import {
  GroupIcon,
  NegobillIcon,
  ProductIcon,
  RefreshIcon,
} from "../../constants/Icons";

const Dashboard = () => {
  const [loadingStatus, setLoadingStatus] = useState({
    storeSummary: false,
    weekSummary: false,
    todayHistory: false,
  });
  const [weekSummary, setWeekSummary] = useState([]);
  const [istodayhistory, setTodayHistory] = useState([]);
  const { permission, hasPermission, hasModulePermission, blockedPermissions } =
    usePermission();
  const [fetchStatus, setFetchStatus] = useState({
    summary: false,
    weekSummary: false,
  });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [summary, setSummary] = useState({
    boxcashTotal: 0,
    saleTotal: 0,
    expenseTotal: 0,
    paylaterData: 0,
    paylaterCustomers: 0,
    totalProducts: 0,
    totalCustomers: 0,
  });
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const { isUser } = useAuth();
  const serverTime = GetServerLiveTime();

  const iso = serverTime.toISOString();
  const currentDate = DateConverter.convertToTimeZone(iso, isUser?.timezone);
  const navigate = useNavigate();
  const REFRESH_INTERVAL_MINUTES = parseInt(
    uRLs.DASHBOARD_REFRESH_INTERVAL || 30,
    10,
  );
  const REFRESH_INTERVAL_MS = REFRESH_INTERVAL_MINUTES * 60 * 1000;
  const LOCAL_STORAGE_KEY = "dashboardLastFetch";

  const updateDashboardCache = (key, data) => {
    const cached = sessionStorage.getItem("dashboardData");
    const parsed = cached ? JSON.parse(cached) : {};
    sessionStorage.setItem(
      "dashboardData",
      JSON.stringify({
        ...parsed,
        [key]: data,
      }),
    );
  };

  const handleStoreSummary = async () => {
    setLoadingStatus((prev) => ({ ...prev, storeSummary: true }));
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/store/`);
      const paylaterBalance =
        response?.data?.results?.paylaterData?.[0]?.totalPaylaterBalance || 0;
      const paylaterCustomers =
        response?.data?.results?.paylaterData?.[0]?.paylaterCustomers || 0;

      setSummary({
        ...response?.data?.results,
        paylaterData: paylaterBalance,
        paylaterCustomers: paylaterCustomers,
      });
      updateDashboardCache("summary", {
        ...response.data.results,
        paylaterData: paylaterBalance,
        paylaterCustomers: paylaterCustomers,
      });
      setFetchStatus((prevStatus) => {
        const newStatus = { ...prevStatus, summary: true };
        sessionStorage.setItem("fetchStatus", JSON.stringify(newStatus));
        return newStatus;
      });
      sessionStorage.setItem("summaryFetched", "true");
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoadingStatus((prev) => ({ ...prev, storeSummary: false }));
    }
  };
  const handleSummary = () => {
    // if (permission === undefined) {
    handleStoreSummary();
    // } else {
    //   showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    // }
  };

  const handleWeekSummary = async () => {
    // if ((hasPermission("DASHBOARD", "SALE:viewWeekSummary") && permission === undefined)) {
    setLoadingStatus((prev) => ({ ...prev, weekSummary: true }));
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/summary/this-week`);
      setWeekSummary(response.data.results);
      updateDashboardCache("weekSummary", response.data.results);
      setFetchStatus((prevStatus) => {
        const newStatus = { ...prevStatus, weekSummary: true };
        sessionStorage.setItem("fetchStatus", JSON.stringify(newStatus));
        return newStatus;
      });

      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoadingStatus((prev) => ({ ...prev, weekSummary: false }));
    }
    // } else {
    //   showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    // }
  };

  const fetchAllData = async () => {
    if (!checkNetwork()) {
      return;
    }
    // await handleStoreSummary();
    // await handleWeekSummary();
    await handleTodayHistory();
    sessionStorage.setItem(LOCAL_STORAGE_KEY, Date.now().toString());
  };

  useEffect(() => {
    const lastFetch = sessionStorage.getItem(LOCAL_STORAGE_KEY);
    const cachedFetchStatus = sessionStorage.getItem("fetchStatus");
    const now = Date.now();

    if (cachedFetchStatus) {
      setFetchStatus(JSON.parse(cachedFetchStatus));
    }

    if (!lastFetch || now - parseInt(lastFetch, 10) >= REFRESH_INTERVAL_MS) {
      fetchAllData();
    } else {
      const cached = sessionStorage.getItem("dashboardData");
      if (cached) {
        const parsed = JSON.parse(cached);
        setSummary(parsed.summary || {});
        setWeekSummary(parsed.weekSummary || []);
        setTodayHistory(parsed.todayhistory || []);
      }
    }
  }, [REFRESH_INTERVAL_MS]);

  const handleTodayHistory = async () => {
    if (
      !(
        hasPermission("DASHBOARD", "SALE:viewTodaySummary") ||
        permission === undefined
      )
    ) {
      return;
    }

    setLoadingStatus((prev) => ({ ...prev, todayHistory: true }));
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      if (!checkNetwork()) return;

      const fromDate = encodeURIComponent(currentDate);
      const toDateWithTime = new Date(currentDate);
      toDateWithTime.setHours(23, 59, 59);
      const toDate = encodeURIComponent(toDateWithTime.toISOString());

      const response = await AxiosInstance.get(
        `module/sale/summary/dateRange?fromdate=${fromDate}&todate=${toDate}`,
      );
      const result = response?.data?.results;
      updateDashboardCache("todayhistory", result);
      setTodayHistory(result);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoadingStatus((prev) => ({ ...prev, todayHistory: false }));
    }
  };
  const totalSummaryData = [
    {
      name: "Today Sale",
      description: "Total sales for today",
      icon: "ng ng-ng-negobill_icon",
      budget: `₹${CurrencyConverter.toCurrency(summary.saleTotal || 0, "INR")}`,
      color: "text-primary",
      bgColor: "bg-light-blue",
      path: "/listsale",
      condition: hasModulePermission("SALE") || permission === undefined,
    },
    {
      name: "Box Cash",
      description: "Current cash ",
      budget: `₹${CurrencyConverter.toCurrency(summary.boxcashTotal || 0, "INR")}`,
      icon: "bx bx-money",
      color: "text-pink",
      bgColor: "bg-label-expense",
      path: "/boxcash",
      condition: hasModulePermission("BOXCASH") || permission === undefined,
    },
    {
      name: "Expense",
      description: "Total expenses today",
      budget: `₹${CurrencyConverter.toCurrency(summary.expenseTotal || 0, "INR")}`,
      icon: "ng ng-ng-expence-icon",
      color: "text-brown",
      bgColor: "bg-light-brown",
      path: "/expense",
      condition:
        uRLs.EXPENSE_MODULE === "true" &&
        (hasModulePermission("EXPENSE") || permission === undefined),
    },

    {
      name: "Pay Later",
      description: "Total Pay Later",
      budget: `₹${CurrencyConverter.toCurrency(summary.paylaterData || 0, "INR")}`,
      icon: "ng ng-ng-card-paylater-icon",
      color: "text-paylater",
      bgColor: "bg-light-paylater",
      path: "/paylater",
      fontSize: "20px",
      condition: hasModulePermission("PAYLATER") || permission === undefined,
    },
    {
      name: "Pay Later Customers",
      description: "Total customers with due",
      budget: `${summary.paylaterCustomers}`,
      icon: "ng ng-ng-customers-icon",
      color: "text-warning",
      bgColor: "bg-label-warning",
      path: "/paylater",
      fontSize: "20px",
      condition: hasModulePermission("PAYLATER") || permission === undefined,
    },
    {
      name: "Total Customer",
      description: "Total  customers",
      budget: summary.totalCustomers,
      icon: "ng ng-ng-customers-icon",
      color: "text-warning",
      bgColor: "bg-label-warning",
      path: "/customer",
      fontSize: "20px",
      condition: hasModulePermission("CUSTOMER") || permission === undefined,
    },
    {
      name: "Product",
      description: "Total products",
      budget: summary.totalProducts,
      icon: "ng ng-ng-product-icon",
      color: "text-info",
      bgColor: "bg-light-blue",
      path: "/listproduct",
      fontSize: "20px",
      condition:
        isUser.stype === "MAIN" &&
        (hasModulePermission("PRODUCT") || permission === undefined),
    },
  ];

  const ProjectItem = ({
    name,
    description,
    budget,
    path,
    icon,
    fontSize,
    color,
    bgColor,
    isLastItem,
    index,
    hoveredIndex,
    setHoveredIndex,
  }) => {
    const budgetString = String(budget);
    const numericBudget = parseFloat(budgetString.replace(/[^0-9.-]+/g, ""));
    const isNegative = !isNaN(numericBudget) && numericBudget < 0;

    let badgeClass = "bg-label-primary";
    if (isNegative) {
      badgeClass = "bg-label-danger";
    } else if (name === "Box Cash") {
      badgeClass = "bg-label-success";
    }
    let formattedBudget = budget;
    if (isNegative) {
      const absoluteBudget = Math.abs(numericBudget);
      formattedBudget = `-₹${absoluteBudget}`;
    }

    const handleNavigation = (destinationPath) => {
      if (destinationPath) {
        navigate(destinationPath);
      }
    };
    const handleMouseEnter = () => {
      setHoveredIndex(index);
    };

    const handleMouseLeave = () => {
      setHoveredIndex(null);
    };
    const listItemClass = `d-flex  align-items-center cursor-poInter p-2 ${isLastItem ? "" : "mb-2"}  ${index === hoveredIndex ? `${bgColor} highlighted-store ` : ""}`;
    return (
      <li
        className={`${listItemClass} `}
        onClick={() => handleNavigation(path)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* bg-lightest */}
        <div class="avatar avatar-md flex-shrink-0 me-4 ">
          <div class={`avatar-initial ${bgColor} rounded-3`}>
            <div>
              <i className={`${icon} ${color} ${fontSize} `}></i>
            </div>
          </div>
        </div>
        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
          <div className="me-2">
            <h6 className="mb-0">{name}</h6>
            <small className="font-13">{description}</small>
          </div>
          <div className={`badge rounded-pill ${badgeClass}`}>
            {formattedBudget}
          </div>
        </div>
      </li>
    );
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          {(hasModulePermission("DASHBOARD") || permission === undefined) && (
            <>
              <div className="page-breadcrumb d-flex align-items-center">
                <div className="breadcrumb-title pe-3 py-2 pt-0">
                  Dashboard
                </div>{" "}
              </div>

              <div className="col-12 mb-3 ">
                <div className="d-flex  align-items-center gap-2 flex-wrap">
                  {(hasModulePermission("CUSTOMER") ||
                    permission === undefined) && (
                    <button
                      type="button"
                      onClick={() => navigate("/customer")}
                      className="btn bg-label-infos dashboard-action-btn mt-2 mt-lg-0 "
                    >
                      <GroupIcon iClass={"me-1"} /> Customer
                    </button>
                  )}

                  {(hasModulePermission("PRODUCT") ||
                    permission === undefined) && (
                    <>
                      {/* {isUser.stype === "MAIN" &&
                        (hasPermission("PRODUCT", "PRODUCT:add") ||
                          permission === undefined) && (
                          <button
                            type="button"
                            className="btn btn-navy dashboard-action-btn d-flex align-items-center gap-2"
                            onClick={() => navigate("/listproduct")}
                          >
                            <ProductIcon iClass={"me-1 fs-6"} />
                            Product
                          </button>
                        )} */}
                      {isUser.stype === "MAIN" &&
                        (hasPermission("PRODUCT", "PRODUCT:add") ||
                          permission === undefined) && (
                          <button
                            className="btn btn-navy dashboard-action-btn d-flex align-items-center gap-2"
                            onClick={() => {
                              navigate("/allproduct");
                            }}
                          >
                            <div className="parent-icon">
                              <ProductIcon iClass={"fs-6"} />
                            </div>
                            <div className="menu-title">Product</div>
                          </button>
                        )}
                      {isUser.stype !== "MAIN" &&
                        (hasPermission("PRODUCT", "PRODUCT:list") ||
                          permission === undefined) && (
                          <button
                            className="btn btn-navy dashboard-action-btn d-flex align-items-center gap-2"
                            onClick={() => {
                              navigate("/listproduct");
                            }}
                          >
                            <div className="parent-icon">
                              <ProductIcon iClass={"fs-6"} />
                            </div>
                            <div className="menu-title">Product</div>
                          </button>
                        )}
                    </>
                  )}
                  {(hasModulePermission("SALE") ||
                    permission === undefined) && (
                    <>
                      {(blockedPermissions("SALE:list") ||
                        permission === undefined) && (
                        <button
                          type="button"
                          className="btn btn-primary dashboard-action-btn"
                          onClick={() => navigate("/listsale")}
                        >
                          <NegobillIcon iClass={"me-2"} />{" "}
                          <span className="">Sale</span>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
              {(hasPermission("DASHBOARD", "SALE:viewTodaySummary") ||
                permission === undefined) && (
                <div className="row">
                  <div className="col-12 ">
                    <div className="card mb-2">
                      <div className="card-header bg-transparent p-3-75">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className=" mb-0 font-18">Today's Overview</h5>

                          <button
                            type="button"
                            className="btn btn-sm btn-light pull-right shadow-none"
                            onClick={handleTodayHistory}
                          >
                            Refresh <RefreshIcon />
                          </button>
                        </div>
                      </div>
                      <CardPreLoader isLoading={loadingStatus.todayHistory} />
                      <TodayHistory data={istodayhistory} />
                    </div>
                  </div>
                </div>
              )}

              <div className="row  pt-1">
                {(hasPermission("DASHBOARD", "STORE:getStoreSummary") ||
                  permission === undefined) && (
                  <div class="col-12 col-md-4">
                    <div class="card">
                      <div className="card-header bg-transparent p-3-75 ">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className=" mb-0 font-18">Store Summary</h5>
                          <div
                            className="refresh-button-container"
                            style={{
                              visibility:
                                fetchStatus.summary &&
                                !loadingStatus.storeSummary
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-light pull-right shadow-none"
                              onClick={handleSummary}
                            >
                              Refresh <RefreshIcon />
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* position-relative */}
                      <div class="card-body ">
                        <CardPreLoader isLoading={loadingStatus.storeSummary} />
                        {!fetchStatus.summary &&
                          !loadingStatus.storeSummary && (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
                              style={{
                                backgroundColor: "rgb(255 255 255 / 62%)",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                zIndex: 2,
                              }}
                            >
                              <button
                                type="button"
                                className="btn btn-sm btn-light pull-right font-20"
                                onClick={handleStoreSummary}
                              >
                                Refresh <RefreshIcon iClass={"font-24"} />
                              </button>
                            </div>
                          )}
                        <ul class="p-0 m-0">
                          {totalSummaryData
                            .filter((item) => item.condition)
                            .map((data, index) => (
                              <ProjectItem
                                key={index}
                                name={data.name}
                                description={data.description}
                                budget={data.budget}
                                icon={data.icon}
                                color={data.color}
                                bgColor={data.bgColor}
                                path={data.path}
                                index={index}
                                fontSize={data?.fontSize || "font-30"}
                                hoveredIndex={hoveredIndex}
                                setHoveredIndex={setHoveredIndex}
                                isLastItem={
                                  index ===
                                  totalSummaryData.filter(
                                    (item) => item.condition,
                                  ).length -
                                    1
                                }
                              />
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {(hasPermission("DASHBOARD", "SALE:viewWeekSummary") ||
                  permission === undefined) && (
                  <div className="col-12 col-md-4 ps-0 ">
                    <div className="card p-2">
                      <div className="card-header bg-transparent p-3-75 border-0">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="mb-1 font-18">Week Sale Summary</h5>
                          <div
                            className="refresh-button-container"
                            style={{
                              visibility:
                                fetchStatus.weekSummary &&
                                !loadingStatus.weekSummary
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-light shadow-none"
                              onClick={handleWeekSummary}
                            >
                              Refresh <RefreshIcon iClass={"shadow-none"} />
                            </button>
                          </div>
                        </div>
                        <p className="mb-0 card-subtitle">This Week</p>
                      </div>
                      <div className="card-body p-0">
                        {!fetchStatus.weekSummary &&
                          !loadingStatus.weekSummary && (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
                              style={{
                                backgroundColor: "rgb(255 255 255 / 62%)",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                zIndex: 2,
                              }}
                            >
                              <button
                                type="button"
                                className="btn btn-sm btn-light pull-right font-20"
                                onClick={handleWeekSummary}
                              >
                                Refresh <RefreshIcon iClass={"font-24"} />
                              </button>
                            </div>
                          )}
                        <CardPreLoader isLoading={loadingStatus.weekSummary} />
                        <WeekSaleSummary weekSummary={weekSummary} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
